import React from 'react';


const InboxEmpty = ({
    message
}) => {
    return (
        <div className='inbox_empty'>
            <div>
            {message}
          </div>
        </div>
    )
}

export default InboxEmpty;